import { ChangeDetectionStrategy, Component } from '@angular/core';
import { isLoading } from '../../../@store/app.selectors';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoaderComponent {
  public isLoading$ = this.store.select(isLoading);

  constructor(private store: Store) {}
}
